import { useEffect } from 'react';
import { PickingInfo } from '@deck.gl/core/typed';
import { MjolnirGestureEvent } from 'mjolnir.js';
import { useSelectedLane } from '../selectedLaneState';

export const useLanesMap = () => {
  const { selectedLane, setSelectedLane } = useSelectedLane();

  useEffect(() => {
    return () => setSelectedLane(undefined);
  }, [setSelectedLane]);

  const onMapClick = (info: PickingInfo, event: MjolnirGestureEvent) => {
    if (!selectedLane || event?.target?.tagName === 'line' || event.rightButton) {
      return null;
    }
    const newCoordinate = info.coordinate as [number, number];
    const coordinates = selectedLane?.geometry?.coordinates ?? [];
    setSelectedLane((prev) => ({
      ...prev,
      geometry: { type: 'LineString', coordinates: coordinates.concat([newCoordinate]) },
    }));
  };

  return {
    onMapClick,
  };
};
